const BASE_URL = process.env.REACT_APP_API_KEY;
const SYNC_BASE_URL = process.env.REACT_APP_SYNC_BASE_URL;
const PDF_BASE_URL = process.env.REACT_APP_PDF_API_URL;
// _____________ AUTHENTICATION _____________
export const GET_AUTHENTICATION = `${BASE_URL}me/`; //GET
export const POST_REFRESH_AUTH = `${BASE_URL}refresh/`; //POST
export const CHANGE_PASSWORD_API = `${BASE_URL}change-password/`; //POST
export const VALIDATE_TOKEN = `${BASE_URL}validate-token/`; //POST
//_____________ QUESTION CREATION _____________
export const POST_INITIALIZING_QUESTION_CREATION = `${BASE_URL}initialize-question-creation/`; //POST
export const PATCH_SELECT_QUESTION = `${BASE_URL}question-draft/`; //GET
export const GET_FREE_TAG = `${BASE_URL}free-tags/`; //GET
export const GET_QUESTIOB_TYPE = `${BASE_URL}question-types/`; //GET
export const GET_AUTHOR = `${BASE_URL}question-authors/`; //GET
// _____________ DOCUMENT LOGGER _____________
export const GET_DOCUMENT_LOGGERLIST = `${BASE_URL}word_doc_logger_table/`; //GET
// _____________ QUESTION LISTING _____________
export const GET_QUESTION_BANK = `${BASE_URL}question-bank/`; //GET
export const GET_QUESTION = `${BASE_URL}question/`; //GET
export const GET_QUESTION_DRAFT = `${BASE_URL}question-draft/`; //GET
export const GET_QUESTION_PREVIEW = `${BASE_URL}`; //GET
// _______________ MASTERS _______________
export const GET_CATEGORY = `${BASE_URL}categories/`; //GET
export const CREATE_CATEGORY = `${BASE_URL}create-category/`; //POST
export const EDIT_CATEGORY = `${BASE_URL}categories/`; //PATCH
export const GET_BANK_LIST_WITH_PERMISSION = `${BASE_URL}users/question-banks-list/`; //GET
export const GET_IDENTIFIER = `${BASE_URL}identifiers/`; //GET
export const CREATE_IDENTIFIER = `${BASE_URL}create-identifier/`; //POST
export const EDIT_IDENTIFIER = `${BASE_URL}identifier/`; //PATCH

export const GET_LOD = `${BASE_URL}lod-list/`; //GET
export const CREATE_LOD = `${BASE_URL}create-lod/`; //POST
export const LOD = `${BASE_URL}lod/`; //PATCH

export const GET_QUESTIONBANK = `${BASE_URL}question-banks/`;
export const GET_QUESTIONS_AND_TAGS = `${BASE_URL}users/fetch-question-banks-tags/`; //GET
export const CREATE_QUESTIONBANK = `${BASE_URL}create-question_bank/`; //POST
export const EDIT_QUESTIONBANK = `${BASE_URL}question-banks/`; //PATCH

export const GET_QUESTIONBANK_METATAG_SUGGESTIONS = `${BASE_URL}question-banks/metatags/suggestions/`;

export const GET_SUBJECT_TAG = `${BASE_URL}subject-tags/`; //GET
export const CREATE_SUBJECT_TAG = `${BASE_URL}create-subject-tags/`; //POST
export const EDIT_SUBJECT_TAG = `${BASE_URL}subject-tags/`; //PATCH
export const GET_TEST_TYPE_LIST = `${BASE_URL}test_types/`; //GET
export const GET_PRODUCT_TYPE_LIST = `${BASE_URL}product-types/`; //GET

// ________ USERS ___________
export const GET_USERS = `${BASE_URL}users/`; //GET
export const GET_ROLES = `${BASE_URL}roles/`; //GET
export const GET_USERS_ROLES_LIST = `${BASE_URL}users/user-roles/`; //
export const CREATE_USERS = `${BASE_URL}create-user/`; //POST

// ___________ organization ___________
export const GET_ORGANISATION = `${BASE_URL}organizations/`; //GET
export const GET_ORGANIZATION_DROPDOWNLIST = `${BASE_URL}organizations_drop/`; //GET
export const GET_USER_ORGANIZATIONDROPDOWNLIST = `${BASE_URL}organization_list/`; //GET
//______________ review _________________organizations
export const GET_REVIEW_DATA = `${BASE_URL}review/question-listing/`;
export const EDIT_REVIEW_STATUS = `${BASE_URL}review/`;

// ______________ GET_REPORT_DATA ______________
export const GET_REPORT_DATA = `${BASE_URL}reports/view/`;

export const GET_REPORT_LIST = (orgId: any, keyword?: any, sort?: any, limit?: any, currentPage?: any) =>
  `${BASE_URL}reports/distribution-reports/${orgId}/?keyword=${keyword ?? ''}&sort=${sort}&limit=${limit}&page=${currentPage}`;
export const GET_REPORT_DOWNLOAD = `${BASE_URL}reports/distribution_report_download/`;
export const GET_REPORTDETAIL_LIST = (orgId: any, id: any) =>
  `${BASE_URL}reports/${id}/distribution-report-result/${orgId}/`;
export const GET_REPORTQUESTIONBANK_LIST = (orgId: any) => `${BASE_URL}reports/question-bank-list/${orgId}/`;
export const GET_REPORT_QUESTIONTYPE = `${BASE_URL}test-question-types/`;
export const GET_REPORT_CATEGORYLIST = `${BASE_URL}test-category-list/`;
export const GET_REPORT_AUTHORLIST = `${BASE_URL}reports/author-list/`;
export const CREATE_REPORT = `${BASE_URL}reports/create-distribution-report/`;
// ________ TASKS ___________
export const GET_TASKS = `${BASE_URL}tasks/`;
export const GET_TASKS_STATUS_API = `${BASE_URL}tasks/task-status/`;
export const GET_TASKS_TYPE_API = `${BASE_URL}tasks/task-type/`;
//GET
// export const GET_ROLES= `${BASE_URL}roles/`  //GET
export const GET_TASK_USERS = `${BASE_URL}tasks/task-user-list/`; //GET
export const GET_TASK_QUESTION_BANK_LIST = `${BASE_URL}tasks/task-question-bank-list/`; //Get
export const CREATE_TASKS = `${BASE_URL}tasks/create_task/`; //POST
export const CREATE_NEW_TASK = `${BASE_URL}tasks/`; //POST
export const GET_TASKS_OF_USER = `${BASE_URL}tasks/fetch_in-progress_tasks/`; //GET
export const TASKS_COMMENTS = `${BASE_URL}tasks/comment-task/`; //POST
export const TAGGED_USERS = (orgId: any, taskId: any) =>
  `${BASE_URL}tasks/tagged-user-list/${orgId}/?task_id=${taskId}`;
export const CREATE_ACTIVITY = `${BASE_URL}tasks/create-activity/`; //POST
export const GET_TASKS_COMMENTS = `${BASE_URL}tasks/view-comments/`;
export const GET_TASKS_LABEL = `${BASE_URL}task-label-list/`;

export const GET_ACTIVITIES = (orgId: any, taskId: any) =>
  `${BASE_URL}tasks/task-recent-activity/${orgId}/?task_id=${taskId}&limit=15&page=1`; //GET
export const GET_TASK_TYPE = `${BASE_URL}tasks/task-type/`; //GET
export const GET_RECENT_ACTIVITIES = (orgId: any) => `${BASE_URL}tasks/user-recent-activity/${orgId}/`; //GET
export const VIEW_ACTIVITY = (orgId: any, taskId: any, limit: any, page: any) =>
  `${BASE_URL}tasks/task-recent-activity/${orgId}/?limit=${limit}&page=${page}&task_id=${taskId}`;

// ________ TEST CREATION ___________
export const CREATE_TESTS_BASIC_SETTING = `${BASE_URL}tests/basic_settings/`; //POST
export const CREATE_TESTS_SECTION = `${BASE_URL}tests/`; //GET
export const GET_TEST_LISTS = `${BASE_URL}tests/`; //GET

//__________SECTION RULE LIST___________
export const VALIDATE_SECTION_RULE = `${BASE_URL}tests/`; //POST
export const GET_SECTION_RULE_LIST = `${BASE_URL}tests/loft-rules-list/`; //GET
export const DELETE_SECTION_RULE_LIST = `${BASE_URL}tests/loft-rules/rule-delete/`; //DELETE

export const GET_PRODUCT = `${BASE_URL}product_types/`; //GET
export const GET_BROWSE_QUESTION = `${BASE_URL}tests/browse_questions/`; //GET
export const GET_QUASI_BROWSE_QUESTION = `${BASE_URL}tests/quasi-browse-questions/`; //GET
export const GET_QUASI_SECTION_QUESTION = `${BASE_URL}tests/quasi-question-listing/`; //GET
export const GET_REPLACE_THIS_QUESTION = `${BASE_URL}tests/replace-question/`; //GET
export const GET_QUESTIONBANK_LIST = `${BASE_URL}tests/test_question_banks/`;
export const GET_PDF_DATA = `${BASE_URL}tests/`;
export const GET_QUESTION_TYPES = `${BASE_URL}test-question-types/`;
export const DELETE_SECTION_RULE_SUBRULE_LIST = `${BASE_URL}tests/loft-rules/rule-delete/`;
export const LOFT_SINGLE_BROWSING = `${BASE_URL}tests/search-loft-single-format-questions/`;
export const LOFT_REPLACE_QUESTIONS = `${BASE_URL}tests/replace-rule-question/`;
export const ADD_SINGLE_LOFT_ROLE = (orgId: any, testId: any) =>
  `${BASE_URL}tests/${testId}/add-loft-single-format-rule/${orgId}/`;
export const LOFT_GROUP_BROWSING = `${BASE_URL}tests/search-loft-group-format-questions/`;
export const LOFT_GROUP_BROWSING_PAGINATION = `${BASE_URL}tests/loft-group-questions-list/`;
export const ADD_GROUP_LOFT_ROLE = (orgId: any, testId: any) =>
  `${BASE_URL}tests/${testId}/add-loft-group-format-rule/${orgId}/`;
export const GET_GROUP_LOFT_ROLE = (
  ruleId: any,
  orgId: any,
  groupId: any,
  sectionId: any,
  testId: any,
  limit: any,
  sort: any
) =>
  `${BASE_URL}tests/loft-rules/${ruleId}/group-rule-details/${orgId}/?group_id=${groupId}&section_id=${sectionId}&test_id=${testId}&limit=${limit}&sort=${sort}`;
export const GET_SINGLE_LOFT_ROLE = (
  ruleId: any,
  orgId: any,
  groupId: any,
  sectionId: any,
  testId: any,
  limit: any,
  sort: any
) =>
  `${BASE_URL}tests/loft-rules/${ruleId}/single-rule-detail/${orgId}/?group_id=${groupId}&section_id=${sectionId}&test_id=${testId}&limit=${limit}&sort=${sort}`;
export const EDIT_SINGLE_LOFT_ROLE = (testId: any, ruleId: any, orgId: any) =>
  `${BASE_URL}tests/loft-rules/${ruleId}/single-rule-update/${orgId}/?test_id=${testId}`;
export const EDIT_GROUP_LOFT_ROLE = (testId: any, ruleId: any, orgId: any) =>
  `${BASE_URL}tests/loft-rules/${ruleId}/group-rule-update/${orgId}/?test_id=${testId}`;
export const IMS_TEST_STATUS = (testId: any) => `${SYNC_BASE_URL}test/${testId}/sync-status/myims`;
export const TEST_PLAYER_STATUS = (testId: any) => `${SYNC_BASE_URL}test/${testId}/sync-status/test-player`;
export const TEST_PLAYER_QUESTION_BANK_STATUS = (questionBankId: any) =>
  `${SYNC_BASE_URL}question-bank/${questionBankId}/sync-status`;
export const TEST_ID_SEARCH = (orgId: any, keyword: any) =>
  `${BASE_URL}tests/fetch-test-ids/${orgId}/?keyword=${keyword}`;

export const GET_ENHANCED_TEST_PDF = (testId: any) => `${PDF_BASE_URL}pdf/tests/${testId}/enhanced-pdf`; //GET (json)
